import { expVal } from '@atlassian/jira-feature-experiments';
import {
	type RouterDataContext,
	createResource,
	type RouterContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PLANS_BACKLOG } from './resourceTypePlansBacklog.constants.tsx';
import { getBacklog } from './getBacklog.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const plansBacklogResource: RouteResource<any> = createResource({
	type: RESOURCE_TYPE_PLANS_BACKLOG,
	getKey: ({ match }: RouterContext) => {
		const { planId, scenarioId } = match.params;
		return `planPageInitialChecks_${planId != null ? planId : ''}_${
			scenarioId != null ? scenarioId : ''
		}`;
	},
	getData: ({ match }: RouterDataContext): Promise<Response> | undefined => {
		// move this to new resource
		if (!expVal('introduce_resource_loading_on_transition_in_plans', 'isEnabled', false)) return;

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (window.__ARJ_BACKLOG_PROMISE__) return;

		const { planId, scenarioId } = match.params;
		return getBacklog(planId, scenarioId);
	},
	isBrowserOnly: true,
	// Invalidation is implemented here: src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx
	maxAge: Infinity,
});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getPlansBacklogResource = (): RouteResource<any>[] =>
	expVal('introduce_resource_loading_on_transition_in_plans', 'isEnabled', false)
		? [plansBacklogResource]
		: [];
